import { mobileAndTabletDetection } from "../../../../utils/browser";
import '../preview-popup/index.scss';

const PreviewPopup = (props: any) => {
    const { usgClass, imprintImageUrl, style, bgColor, showModal, hideModal } = props;
    const isMobileDevice = mobileAndTabletDetection();
    const closeModal = (e) => {
        const { classList } = e.target;
        const classListArray = [...classList];
        if(classListArray.includes('close') || classListArray.includes('show-preview-imprint-details')) {
            hideModal?.();
            e.stopPropagation();
        } 
    }
    return (
       (imprintImageUrl ? <div className="preview-img-wrap">
            <div id="preview-imprint" data-testid='test-preview-imprint' className={`modal${!isMobileDevice ? ' desktop-img-info' : ''}${usgClass ? ' preview-imprint-usg-details' : ''}${showModal ? ' show-preview-imprint-details' : ''}`} onClick={(e) => closeModal(e)}>
                {/* Modal content */}
                <div className="modal-content">
                    <div>
                        <span tabIndex={0} className="close">&times;</span>
                    </div>	
                    <img alt='imprintImage' src={imprintImageUrl}/>
                </div>
            </div>
            <div className={`hover-image-info${!isMobileDevice ? ' desktop-hover-image-info' : ''} ${usgClass ? usgClass : ''}`} style={style ? style : {}}>
                <div className="preview-popup" style={{'backgroundColor': bgColor}}>	
                    <div className="preview-content">
                        <img alt='imprintImage' src={imprintImageUrl}/>
                    </div>
                </div>													
            </div>
        </div> : null )
    )
}

export default PreviewPopup;